// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"Disclaimer_disclaimer__3LrqL","contactInnovationExpertButton":"Disclaimer_contactInnovationExpertButton__3PXMU"};